import React from "react";

import SweetAlert from "react-bootstrap-sweetalert";
import Select from 'react-select';
import withStyles from "material-ui/styles/withStyles";

import GridContainer from "components/Grid/GridContainer";
import ItemGrid from "components/Grid/ItemGrid";
import Button from "components/CustomButtons/Button.jsx";

//material-ui core
import Dialog from "material-ui/Dialog";
import DialogTitle from "material-ui/Dialog/DialogTitle";
import DialogContent from "material-ui/Dialog/DialogContent";
import DialogActions from "material-ui/Dialog/DialogActions";
import Divider from '@material-ui/core/Divider'

import Close from "@material-ui/icons/Close";
import DeleteIcon from '@material-ui/icons/Delete';
import Tooltip from 'material-ui/Tooltip';

import Table from '../../elements/Table';

import List from 'material-ui/List';
import ListItem from 'material-ui/List/ListItem';
import ListItemAvatar from 'material-ui/List/ListItemAvatar';
import ListItemIcon from 'material-ui/List/ListItemIcon';
import ListItemSecondaryAction from 'material-ui/List/ListItemSecondaryAction';
import ListItemText from 'material-ui/List/ListItemText';

import IconButton from "components/CustomButtons/IconButton";

const styles = theme => ({ root: { overflow: 'visible' } });

class ViewGroupModal extends React.Component{
    constructor(props){
        super(props);
        this.headers = [
            {Header:"User ID",accessor:"uid"},
            {Header:"Username",accessor:"username"},
            {
              Header:"Actions",
              accessor:"actions",
              minWidth: 200,
              sortable:false,
              filterable:false
            }
        ];

    }

    removeMember = (userId, groupId) =>  (event) => {
        this.props.removeMember(userId, groupId, event)
    }
    /*
        TODO: add a proper modal on delete
    */
    test = (function1, test) => {
        
        function1();
    }

    render(){
        const { members, classes, onSelectChange, value, toAddMembers,
             isAddMember, options, addMembers } = this.props;

        return(

            <Dialog
                open={this.props.isOpen}
                onClose={this.props.onClose}
                aria-labelledby="group-modal-title"
                aria-describedby="group-modal-description"
                fullWidth={true}
                maxWidth="xs"
            >
                <DialogTitle 
                    id="group-modal-title"
                >
                    Group Members
                </DialogTitle>
                <DialogContent
                    id="group-modal-description"
                    className={classes.root}
                >
                    {(!isAddMember) ?
                    <GridContainer>
                        
                        <ItemGrid>
                            <Button onClick={toAddMembers}>Add Members</Button>
                        </ItemGrid>
                        <ItemGrid xs={12} md={12} lg={12}>
                            <div>
                              <List dense>
                                {(members) ? 
                                  members.map((member, index) => {
                                    return(
                                        <ListItem key={index}>
                                            <ListItemText
                                              primary={member.username}
                                            />
                                            <ListItemSecondaryAction>
                                              <IconButton onClick={this.removeMember(member.uid,this.props.groupId)} aria-label="Delete" size="sm">
                                                 <DeleteIcon />
                                              </IconButton>
                                            </ListItemSecondaryAction>
                                            <Divider />
                                        </ListItem>
                                        
                                    )
                                  }) : "No members for this group"
                                  
                                }
                              </List>
                            </div>
                        </ItemGrid>    
                    </GridContainer> : 
                    <GridContainer>
                        <ItemGrid xs={12}>
                            <Select 
                                onChange={onSelectChange}
                                options={options}
                                placeholder="Select one or many users"
                                clearable
                                multi
                                isSearchable
                                value={value}
                            /> 
                            <Button onClick={addMembers}>
                                ADD
                            </Button>
                        </ItemGrid>
                    </GridContainer>
                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.onClose}>Close</Button>
                </DialogActions>
            </Dialog>
        )
    }
}

export default withStyles(styles)(ViewGroupModal)


// WEBPACK FOOTER //
// ./src/views/projects/components/ViewGroupModal.jsx